<template>
  <div>
    <NavigationBar @toggle-drawer="drawer = !drawer" />
    <Sidebar v-model="drawer" />
    <v-main class="main-bg">
      <v-container fluid class="pa-6">
        <router-view />
      </v-container>
    </v-main>
    <Notification />
  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue'
import Sidebar from '../components/Sidebar.vue'
import Notification from '../components/Notification.vue'

export default {
  name: 'MainLayout',
  components: { NavigationBar, Sidebar, Notification },
  data() {
    return { drawer: false }
  }
}
</script>

<style scoped>
.main-bg {
  background-color: #333333 !important;
  min-height: 100vh;
}
</style>
